<nav class="vertical-container">
  <ul class="category-list">
    @for (navItem of navContent(); track navItem) {
      <li class="category-list-container">
        @if (navItem.subcategories.length > 0) {
          <button
            class="category-list-item"
            (click)="toggleCategoryItemOpen(navItem)">
            {{ navItem.categoryLabel }}
            <div
              class="category-item-opener"
              [class.rotate-180-deg]="navItem.isOpen">
              <fly-icon icon="chevron-down"></fly-icon>
            </div>
          </button>
        } @else {
          <a
            [routerLink]="navItem.linkUrl"
            class="category-list-item">
            {{ navItem.categoryLabel }}
          </a>
        }
        @if (navItem.subcategories.length > 0) {
          <ul class="subcategory-list">
            @for (subcategory of navItem.subcategories; track subcategory) {
              <li [class.hidden]="!navItem.isOpen">
                <a
                  class="subcategory-list-item"
                  [routerLink]="subcategory.linkUrl">
                  {{ subcategory.subCategoryLabel }}
                </a>
              </li>
            }
          </ul>
        }
      </li>
    }
  </ul>
</nav>
